/*
* 連打防止
*/
const $ = require('jquery')

module.exports = (function () {
  function run () {
    _disabledReleased()

    $('input[type=submit], button[type=submit]').on('click', function () {
      $(this).prop('disabled', 'disabled')
      $(this).parents('form').submit()
      return false
    })
  }
  /*
   * ブラウザバックされた場合などにdisabled状態が残らないように初期化する処理
   * disabledが解除されると困る処理については js-not-disabled-released クラスを付与すること。
   */
  function _disabledReleased () {
    $('input[type=submit], button[type=submit]')
      .not('.js-not-disabled-released')
      .prop('disabled', false)
  }

  return {
    run: run
  }
})()
